import { fetchApi } from '@/config/axiosSetting';
import {
  GetEvaluationSummaryQueryParamsType,
  GetEvaluationSummaryQueryResponseType,
} from './getEvaluationSummaryQuery.type';

export const getEvaluationSummaryFunction = (
  params: GetEvaluationSummaryQueryParamsType,
): Promise<GetEvaluationSummaryQueryResponseType> => {
  return fetchApi.get('/survey/evaluation_summary/', {
    params,
  });
};
